import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import { PayoutHistoryLog } from 'components/organisms/payout-history-log'

interface PayoutHistoryModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	payouts: Array<{
		id: string
		amount: number
		requestedDate: string
		status: 'pending' | 'paid' | 'failed'
		paidDate?: string
		transactionId: string
		notes?: string
	}>
	currencySymbol?: string
}

export function PayoutHistoryModal({ open, setOpen, payouts, currencySymbol }: PayoutHistoryModalProps) {
	return (
		<ContentModal open={open} setOpen={setOpen} isModal size="lg" title="Payout History">
			<div className="relative flex flex-col">
				<div className="max-h-96 overflow-y-auto">
					<PayoutHistoryLog
						payouts={payouts}
						currencySymbol={currencySymbol}
						className="bg-transparent border-none p-0"
					/>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface PayoutHistoryModalManagedProps {
	payouts: Array<{
		id: string
		amount: number
		requestedDate: string
		status: 'pending' | 'paid' | 'failed'
		paidDate?: string
		transactionId: string
		notes?: string
	}>
	currencySymbol?: string
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'payout-history': PayoutHistoryModalManagedProps
	}
}

export function ManagedPayoutHistoryModal({
	onClose,
	...rest
}: PayoutHistoryModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<PayoutHistoryModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			{...rest}
		/>
	)
}
